__turbopack_context__.v({
  "container": "faq-module-scss-module__IwvjrW__container",
  "faq-section": "faq-module-scss-module__IwvjrW__faq-section",
  "header": "faq-module-scss-module__IwvjrW__header",
  "icon": "faq-module-scss-module__IwvjrW__icon",
  "styled-list": "faq-module-scss-module__IwvjrW__styled-list",
  "table": "faq-module-scss-module__IwvjrW__table",
  "table-complement": "faq-module-scss-module__IwvjrW__table-complement",
  "table-faq": "faq-module-scss-module__IwvjrW__table-faq",
  "table-text": "faq-module-scss-module__IwvjrW__table-text",
  "table-unreturned": "faq-module-scss-module__IwvjrW__table-unreturned",
});
